<template>
    <div class="body">
        <!-- <div class="back" @click="$router.go(-1)">
            <img src="../../assets/img/i19.png" />
            返回
        </div> -->
        <div class="nav" @click="$router.go(-1)">
            <img class="n_icon" src="../../assets/img/i19.png" />
            <img class="n_tx" :src="webImg + assistantItem.icon" />
            <div class="n_name">{{ assistantItem.name }}</div>
        </div>
        <div class="chat">
            <div class="ch_bottom" ref="scrollDiv">
                <div class="chb_item" v-for="(item, index) in list" :key="index">
                    <div class="chb_left" v-if="!item.isMine">
                        <img class="hbl_left" :src="webImg + assistantItem.icon" />
                        <div class="hbl_right" :class="isLoading && index == list.length - 1 ? 'hblr_1' : ''">
                            <div class="loading_1" v-show="isLoading && index == list.length - 1">
                                <div class="swiper-container" ref="swiperContainer">
                                    <div class="swiper-wrapper">
                                        <div class="swiper-slide">
                                            AI模型优化中，请稍候……
                                        </div>
                                        <div class="swiper-slide">
                                            AI模型正在进行深度推理，请稍候片刻……
                                        </div>
                                        <div class="swiper-slide">
                                            模型推理任务正在执行，精准结果即将生成……
                                        </div>
                                        <div class="swiper-slide">
                                            智能分析模块正在处理数据，敬请耐心等待……
                                        </div>
                                        <div class="swiper-slide">
                                            AI智能分析中，数据正在快速处理……
                                        </div>
                                        <div class="swiper-slide">
                                            AI模型推理进行中，精准结果即将呈现……
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="blr_top">
                                <!-- <div class="loading-container" v-if="isLoading && index == list.length - 1">
                                    <div class="dot"></div>
                                    <div class="dot"></div>
                                    <div class="dot"></div>
                                </div> -->

                                <div style="color: #757575 !important;border-left: 1px solid #c2c2c2;padding-left: 10px;"
                                    v-html="markedt(item.reasoning_content)" v-if="item.reasoning_content"></div>
                                <div v-html="markedt(preprocessLaTeX(item.text))" style="width: 100%;box-sizing: border-box;word-break: break-all;
						white-space: normal;" v-if="item.text"></div>
                            </div>
                            <!-- index > 0 && index == list.length - 1 && !stop -->
                            <div class="blr_bottom" v-if="index > 0 && item.msgId">
                                <!-- <div class="lrb_btn" @click="btn_reanswer" v-if="!isClose">
                                    <img src="../../assets/img/i24.png" />
                                    再来一次
                                </div> -->
                                <div class="lrb_btn" @click="btn_download(item, index)">
                                    <img src="../../assets/img/i23.png" />
                                    下载
                                </div>
                                <div class="lrb_btn" @click="handleClipboard(item.text, $event)">
                                    <img src="../../assets/img/i22.png" />
                                    复制
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="chb_right" v-if="item.isMine">
                        <div class="file" style="justify-content: flex-end;">
                            <div class="f_item" v-for="(itemA, indexA) in item.fileList" :key="indexA">
                                <img class="fi_icon" :src="settingFileIcon(itemA.resourceType, itemA.path)" />
                                <div class="fi_text line1_">{{ itemA.name || itemA.path }}</div>
                            </div>
                        </div>
                        <div class="hbr_bottom">
                            <div class="hbr_text" v-html="item.text"
                                v-if="item.text && item.text.trim() !== '' && item.text !== '<div></div>' && item.text !== '\n'">
                            </div>
                            <img class="hbr_tx" :src="webImg + userInfo.avatar" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="o_bottom1" v-if="!isClose">
                <img class="ob_down" src="../../assets/img/down.png" v-if="!autoScroll" @click="btn_scrollBottom" />
                <!-- <div class="ob_btn" @click="btn_record">
                    <img src="../../assets/img/i90.png" />
                    聊天记录
                </div> -->
                <div class="file">
                    <div class="f_item" v-for="(item, index) in fileList" :key="index"
                        @click="btn_delFile(item, index)">
                        <img class="fi_icon" :src="settingFileIcon(item.resourceType, item.path)" />
                        <div class="fi_text line1_">{{ item.name || item.path }}</div>
                        <img class="fi_del" src="../../assets/img/i52.png" />
                    </div>
                </div>
                <textarea placeholder="请输入..." v-model="inputContent" @keyup="carriageReturn"></textarea>
                <div class="ob_bottom1">
                    <!-- <div class="obb_left">R1深度思考</div> -->
                    <div class="obb_right">
                        <!-- <img class="bbr_1" src="../../assets/img/i7.png" /> -->
                        <el-upload :headers="myHeaders" :http-request="handleUploadForm" :on-change="imgSaveToUrl"
                            :show-file-list="false" action class="upload-demo" multiple
                            accept=".doc,.docx,.pdf,.xls,.xlsx,.ppt,.pptx">
                            <img class="bbr_1" src="../../assets/img/i7.png" />
                        </el-upload>
                        <el-upload :headers="myHeaders" :http-request="handleUploadImgForm" :on-change="imgSaveToUrl"
                            :show-file-list="false" action class="upload-demo" multiple accept="image/*">
                            <img class="bbr_1" src="../../assets/img/i8.png" />
                        </el-upload>
                        <img class="bbr_2" src="../../assets/img/i9.png" @click="btn_send" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper, { Autoplay, EffectCoverflow } from 'swiper';
import 'swiper/swiper.min.css';
import 'swiper/swiper-bundle.css';
Swiper.use([Autoplay, EffectCoverflow]);


import { fetchEventSource } from '@microsoft/fetch-event-source';
import axios from 'axios'
import MarkdownIt from 'markdown-it'
import '@/assets/katex/dist/katex.min.css';
import { downloadSessionMsg, helperInfo, promptInfo, ossToken, fileResourceList, addScore, helperUploadFileToKimi, createSession, helperMsgDetailList, classroomTestInfo,classroomTestCreateSessionStu } from '@/apis/index'
import Clipboard from 'clipboard'
// import markdownItKatex from 'markdown-it-katex';
import markdownItKatex from '@iktakahiro/markdown-it-katex';

const markdownRender = new MarkdownIt({
    html: true,
    linkify: true,
    typographer: true,
    breaks: true
});
markdownRender.use(markdownItKatex);
export default {
    data() {
        return {
            list: [],
            flag: false,
            userInfo:JSON.parse(sessionStorage.getItem('userInfos')) || JSON.parse(localStorage.getItem('userInfo')) || {},
            sourceType: '',
            info: {},
            prompts: '',
            stop: false,
            isLoading: false,
            controller: null,
            inputContent: '',
            eventSource: null,
            myHeaders: { "X-Token": ossToken() },
            hover: false,
            sessionId: '', //会话ID
            reAnswerFlag: false,
            fileList: [],
            assistantId: '',
            assistantItem: {},
            isClose: false,
            templateList: this.$route.query.templateList,
            msgId: '',

            autoScroll: true, // 是否自动滚动到底部

        }
    },
    mounted() {
        if (this.$route.query.techClassHelperId) {
            this.techClassHelperId = this.$route.query.techClassHelperId
            this.getCreateSession()
        }
        const scrollElem = this.$refs.scrollDiv;
        scrollElem.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        const scrollElem = this.$refs.scrollDiv;
        scrollElem.removeEventListener('scroll', this.handleScroll);
    },
    methods: {

        btn_download(item, index) {
            downloadSessionMsg(item.msgId).then((res) => {
                console.log(res, 'downloadSessionMsg');
                window.open(this.webImg + res.data);
            });
        },
        btn_record() {
            this.$router.push({
                name: 'intelligentBodyRecord',
                query: {
                    id: this.assistantId,
                    sessionId: this.sessionId,
                }
            })
        },
        getHelperMsgDetailList() {
            helperMsgDetailList(this.sessionId).then((res) => {
                console.log(res, 'helperMsgDetailList');
                if (res.data.techHelperMsgs.length > 0) {
                    if (res.data.techHelperMsgs[res.data.techHelperMsgs.length - 1].isEnt == 1) {
                        this.isClose = true
                    }
                    res.data.techHelperMsgs.forEach((e, i) => {
                        this.list.push({
                            id: e.id,
                            text: e.content,
                            isMine: e.senderType == 1,
                            time: e.time,
                            imgArr: e.path ? e.path.split(',') : ''
                        });
                    });
                    this.msgId = res.data.techHelperMsgs[res.data.techHelperMsgs.length - 1]?.id; // 使用可选链避免错误
                    setTimeout(() => {

                        this.handleScrollBottom();
                    }, 500);
                }
            });
        },
        getInfo() {
            classroomTestInfo(this.assistantId, this.sessionId).then((res) => {
                console.log(res, 'classroomTestInfo');
                this.assistantItem = res.data
                if (res.data && res.data.type == 4) {
                    this.helperId = res.data.id;
                }
                this.getHelperMsgDetailList();
            });
        },
        btn_delFile(item, index) {
            this.fileList.splice(index, 1);
            this.$forceUpdate();
        },
        // 上传
        handleUploadForm(param) {
            const formData = new FormData();
            formData.append("multipart", param.file);
            let loading = this.$loading({
                lock: true,
                text: "上传中，请稍候...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            // 获取上传token
            ossToken(param.file.name).then(res => {
                let ossRes = JSON.parse(res.data);
                console.log(ossRes, 'getOssToken')
                const ossData = new FormData();
                Object.keys(ossRes).forEach((key) => {
                    ossData.append(key, ossRes[key]);
                });
                ossData.append("file", param.file);
                var url = ossRes.host;
                axios({
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    method: 'post',
                    url: url,
                    data: ossData
                }).then(async (res2) => {
                    console.log(res2, 'getOssToken axios')
                    this.fileList.push({
                        path: res2.data.url,
                        resourceType: 3,
                        select: 1,
                        name: param.file.name
                    })
                    loading.close();
                })
            })
        },
        handleUploadImgForm(param) {
            console.log(param, 'imgup');
            const formData = new FormData();
            formData.append("multipart", param.file);
            let loading = this.$loading({
                lock: true,
                text: "上传中，请稍候...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            // 获取上传token
            ossToken(param.file.name).then(res => {
                let ossRes = JSON.parse(res.data);
                console.log(ossRes, 'getOssToken')
                const ossData = new FormData();
                Object.keys(ossRes).forEach((key) => {
                    ossData.append(key, ossRes[key]);
                });
                console.log(param.file, 'param.file')
                ossData.append("file", param.file);
                var url = ossRes.host;
                axios({
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    method: 'post',
                    url: url,
                    data: ossData
                }).then(async (res2) => {
                    console.log(res2, 'getOssToken axios')
                    this.fileList.push({
                        path: res2.data.url,
                        resourceType: 2,
                        select: 1,
                        name: param.file.name
                    })
                    console.log(this.icon, 'icon');
                    loading.close();
                })
            })
        },
        // 选取图片后自动回调，里面可以获取到文件
        imgSaveToUrl(event) {
            console.log(event, 'eventOnchange');
        },
        arrayToRichText(array) {
            let html = '<div>';
            for (let i = 0; i < array.length; i++) {
                if (!array[i].attrName) {
                    html += `<div>${array[i].title + ':  ' + (array[i].defaultVal || '')}</div>`;
                } else if (array[i].attrName) {
                    html += `<div>${array[i].attrName + ':  ' + (array[i].selectName || '')}</div>`;
                }
            }
            html += '</div>';
            return html;
        },
        textReplace() {
            // 创建一个新的 Map
            const dataMap = new Map();
            // 使用 forEach 方法填充 Map
            this.templateList.forEach(obj => {
                if (obj.defaultVal) {
                    dataMap.set(obj.title, obj.defaultVal);
                }
            });
            console.log(dataMap, 'dataMap');
            // 替换字符串中的占位符
            this.prompts = this.prompts.replace(/{(.*?)}/g, (match, key) => {
                console.log(dataMap.get(key) || match, 'ssssss');
                return dataMap.get(key) || ''; // 如果找不到对应的值，则保留原始占位符
            });
            console.log(this.prompts, 'prompts');
        },
        btn_reanswer() {
            this.reAnswerFlag = true
            this.btn_send()
        },
        btn_send() {
            this.flag2 = true
            // 只有当eventSource不存在时才创建新的EventSource连接
            if (!this.stop) {
                this.controller = new AbortController();
                const { signal } = this.controller;
                var msg = ''
                if (this.inputContent.trim() == '' && !this.reAnswerFlag && this.fileList.length == 0) {
                    return this.$message.warning('请先输入内容')
                }
                if (!this.inputContent) {
                    this.textReplace()
                    msg = this.arrayToRichText(this.templateList)
                } else {
                    msg = this.inputContent
                }
                console.log(msg, 'msg');
                var flist = []
                if (this.fileList.length > 0) {
                    flist = this.fileList.map(e => e.path)
                }
                if (!this.reAnswerFlag) {
                    this.list.push({ text: msg, isMine: true, fileList: [...this.fileList], time: this.getDateTime2(new Date().getTime()) });
                }
                this.list.push({ text: "", isMine: false, time: this.getDateTime2(new Date().getTime()), reasoning_content: '', });
                this.handleScrollBottom()
                var this_ = this
                this.stop = true
                this.isLoading = true
                setTimeout(() => {
                    this.swiper = new Swiper(this.$refs.swiperContainer, {
                        direction: 'vertical',
                        loop: true,
                        slidesPerView: 3,
                        centeredSlides: true,
                        spaceBetween: 5,
                        effect: 'slide',  // 关闭 coverflowEffect，改用 slide
                        // effect: 'coverflow',
                        coverflowEffect: {
                            rotate: 0,       // 取消旋转，保持垂直排列
                            stretch: 0,
                            depth: 50,
                            modifier: 1,
                            slideShadows: false,
                        },
                        autoplay: {
                            delay: 900,
                            disableOnInteraction: false,
                        },
                        allowTouchMove: false,  // 禁止用户拖拽滑动
                        speed: 800,  // 切换动画时长，单位毫秒，越大越慢
                    });
                }, 200);
                // 创建新的EventSource连接
                var url = process.env.VUE_APP_BASE_API + `presetHelper/completions`
                this.eventSource = fetchEventSource(url, {
                    method: 'POST',
                    headers: {
                        "Content-Type": 'application/json',
                        "Accept": 'text/event-stream',
                        "token": localStorage.getItem('token')
                    },
                    body: JSON.stringify({
                        sessionId: this.sessionId,
                        messages: this.inputContent,
                        prompts: this.templateList ? this.templateList : '',
                        filePathList: flist,
                        reAnswerFlag: this.reAnswerFlag
                    }),
                    signal: signal,
                    openWhenHidden: true,
                    onmessage(event) {
                        this_.templateList = ''
                        if (event.data && this_.isLoading) {
                            this_.isLoading = false
                        }
                        this_.reAnswerFlag = false
                        let dataJ = JSON.parse(event.data)
                        if (dataJ.name) {
                            this_.msgId = dataJ.name
                            this_.list[this_.list.length - 1].msgId = dataJ.name
                        }
                        if (dataJ.error == 0) {
                            this_.isClose = true;
                            this_.close()
                        }
                        if (dataJ.reasoning_content) {
                            this_.list[this_.list.length - 1].reasoning_content += dataJ.reasoning_content;
                            console.log(this_.list[this_.list.length - 1].reasoning_content, 'sss');
                        }
                        this_.list[this_.list.length - 1].text += dataJ.content;
                        this_.$forceUpdate()
                        this_.handleScrollBottom()
                    },
                    onclose(ee) {
                        console.log('close');
                        // 关闭流
                        this_.close()
                        this_.handleScrollBottom()
                        this_.autoScroll = true

                    },
                    onerror(error) {
                        console.log(error, '返回流报错');
                        //返回流报错

                    }
                });
                console.log(this.eventSource, 'eventSource');
                this.inputContent = ''
                this.fileList = []
            }
        },
        close() {
            this.controller.abort();
            this.controller = null
            this.stop = false
            this.isLoading = false
        },
        btn_scrollBottom() {
            let scrollElem = this.$refs.scrollDiv;
            scrollElem.scrollTo({ top: scrollElem.scrollHeight, behavior: 'smooth' });
        },
        handleScroll() {
            const scrollElem = this.$refs.scrollDiv;
            // 判断是否接近底部，阈值可以调整
            const threshold = 50;
            const isBottom = scrollElem.scrollHeight - scrollElem.scrollTop - scrollElem.clientHeight < threshold;
            console.log(isBottom, 'isBottom');

            this.autoScroll = isBottom;
        },
        // 滚动到底部
        handleScrollBottom() {
            if (!this.autoScroll) return; // 如果用户手动滚动了，不自动滚动
            this.$nextTick(() => {
                const scrollElem = this.$refs.scrollDiv;
                scrollElem.scrollTo({ top: scrollElem.scrollHeight, behavior: 'smooth' });
            });
            // this.$nextTick(() => {
            //     let scrollElem = this.$refs.scrollDiv;
            //     scrollElem.scrollTo({ top: scrollElem.scrollHeight, behavior: 'smooth' });
            // });
        },
        handleClipboard(text, event) {
            console.log(event);
            const clipboard = new Clipboard(event.target, {
                text: () => text
            })
            clipboard.on('success', () => {
                this.clipboardSuccess()
                clipboard.destroy()
            })
            clipboard.on('error', () => {
                this.clipboardError()
                clipboard.destroy()
            })
            clipboard.onClick(event)
        },
        clipboardSuccess() {
            this.$message.success('复制成功')
        },
        clipboardError() {
            this.$message.error('复制失败')
        },

        carriageReturn(event) {
            let e = window.event || arguments[0];
            if (!e.ctrlKey && e.keyCode == 13) {
                e.returnValue = false;
                this.btn_send();
                return false;
            }
        },
        copyContent(text) {
            navigator.clipboard.writeText(text)
                .then(() => {
                    this.$message.success('复制成功')
                }).catch(err => {
                    console.error('无法复制文本: ', err);
                });
        },
        markedt(markdown) {
            if (markdown) {
                // // 预处理：修复列表换行问题
                // const fixedMarkdown = markdown.replace(/([^\n])\n(\d+\.)/g, '$1\n\n$2');
                // 处理转义换行符（单反斜杠转双反斜杠）
                const processedText = markdown.replace(/\n/g, '\n ');
                return markdownRender.render(processedText);
            }
            return '';
        },
        getCreateSession() {
            classroomTestCreateSessionStu(this.techClassHelperId).then(res => {
                console.log(res, 'classroomTestCreateSessionStu');
                this.sessionId = res.data.id;
                this.assistantId = res.data.helperId;
                this.getInfo()
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.swiper-container {
    position: relative;
    /* 伪元素定位基准 */
    width: 100%;
    height: 100%;
    overflow: visible;
}

/* 顶部虚化遮罩 */
.swiper-container::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 10px;
    pointer-events: none;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    z-index: 10;
}

/* 底部虚化遮罩 */
.swiper-container::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 10px;
    pointer-events: none;
    z-index: 10;
}

.swiper-wrapper {
    /* 让 wrapper 高度撑满容器 */
    height: 100%;
}

.swiper-slide {
    filter: blur(0.5px);
    height: 23.3px;
    font-size: 10px;
    font-weight: 500;
    color: #76848d;
    border-radius: 6px;
    user-select: none;
    transition: transform 0.3s ease, opacity 0.3s ease;
    width: 100%;
    text-align: left;
    box-sizing: border-box;
    padding: 0 20px;
}

.swiper-slide-active {
    filter: none;
    font-size: 10px;
    font-weight: bold;
    color: #000;
    transform: scale(1.1);
}

.swiper-container {
    perspective: 800px;
    /* 开启3D透视 */
}

.swiper-slide {
    filter: blur(0.5px);
    height: 23.3px;
    font-size: 10px;
    font-weight: 500;
    color: #76848d;
    border-radius: 6px;
    user-select: none;
    width: 100%;
    text-align: left;
    transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1), filter 0.5s ease;
    transform-origin: center center;
    /* 初始状态稍微缩小并后移 */
    transform: scale(0.8) translateZ(-50px);
    opacity: 0.6;
}

.swiper-slide-active {
    filter: none;
    font-weight: bold;
    color: #000;
    transform: scale(1.1) translateZ(0);
    opacity: 1;
    z-index: 10;
}

.swiper-slide-next {
    filter: blur(0.5px);
    font-weight: 500;
    color: #76848d;
    /* 下一条滑块从大到小，由近到远 */
    transform: scale(1.3) translateZ(50px);
    opacity: 0.8;
    z-index: 5;
}

.swiper-slide-prev {
    filter: blur(0.5px);
    font-weight: 500;
    color: #76848d;
    transform: scale(0.7) translateZ(-70px);
    opacity: 0.5;
    z-index: 5;
}

.loading_1 {
    width: 300px;
    height: 70px;
    border-radius: 6px;
    background: radial-gradient(35.14% 108.05% at 28.3% 24.71%, rgba(157, 206, 255, .3) 0, rgba(157, 206, 255, .15) 58.31%, rgba(157, 206, 255, .09) 100%), rgba(0, 0, 0, .3);
    overflow: hidden;
    box-sizing: border-box;
    padding: 5px 10px 0 10px;
}

::v-deep {
    .el-carousel__container {
        height: 70px !important;
        padding: 0 10px;
        /* 给轮播容器左右内边距 */
    }

    .el-carousel__item {
        height: fit-content !important;
    }

    .el-carousel__item {
        // transform: translateY(40px) scale(1) !important;
    }

    .el-carousel__mask {
        background: transparent !important;
    }

    // , .el-carousel__mask
    .el-carousel__item {
        height: fit-content !important;
    }

    ol,
    ul {
        padding-left: 2em;

    }

    li {
        list-style: decimal !important;
    }

    code {
        /*元素内的空白保留，并允许换行*/
        white-space: pre-wrap !important;
        /*是否允许在单词内断句*/
        word-wrap: break-word !important;
        font-family: PingFang;
    }

    .katex-html {
        // display: none !important;
    }

    annotation {
        display: none !important;
    }

    table {
        border-collapse: collapse;
        /* 确保表格的边框线会合并为单一的线条 */
        border: 1px solid black;
        /* 设置表格的边框 */
    }

    td,
    th {
        border: 1px solid black;
        /* 设置单元格的边框 */
    }

    h1 {
        font-size: 16px;
        font-weight: bold;
    }

    h2 {
        font-size: 16px;
        font-weight: bold;
    }

    h3 {
        font-size: 16px;
        font-weight: bold;
    }

    p {
        font-size: 16px;
    }

    li {
        font-size: 16px;
    }
}

.file {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .f_item:nth-child(3n) {
        margin-right: 0 !important;
    }

    .f_item {
        width: 262px;
        height: 55px;
        border-radius: 8px;
        box-sizing: border-box;
        padding: 8px;
        display: flex;
        align-items: center;
        background-color: rgba(0, 0, 0, 0.03);
        margin-right: 15px;
        margin-bottom: 15px;

        .fi_icon {
            width: 30px;
            height: 30px;
        }

        .fi_text {
            color: #000000;
            font-size: 14px;
            font-weight: 500;
            flex: 1;
            margin: 0 10px;
        }

        .fi_del {
            width: 20px;
            height: 20px;
            cursor: pointer;
        }
    }
}

.body {
    width: 1200px;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;

    .back {
        width: 100%;
        display: flex;
        align-items: center;
        font-weight: bold;
        font-size: 14px;
        color: #000000;
        // margin-bottom: 10px;
        margin-top: 10px;
        cursor: pointer;
        box-sizing: border-box;

        img {
            width: 14px;
            height: 14px;

        }
    }

    .nav {
        width: 900px;
        height: 60px;
        background-color: #fff;
        box-sizing: border-box;
        padding: 0 15px;
        display: flex;
        align-items: center;
        margin-top: 10px;
        border-radius: 8px 8px 0 0;
        cursor: pointer;

        .n_icon {
            width: 14px;
            height: 14px;
        }

        .n_tx {
            width: 44px;
            height: 44px;
            border-radius: 4px;
            margin: 0 15px;
        }

        .n_name {
            font-weight: bold;
            font-size: 16px;
            color: #000000;
        }
    }

    .chat {
        width: 900px;
        height: 0;
        flex: 1;
        box-sizing: border-box;
        padding: 0 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        border-left: 1px solid#fff;
        border-right: 1px solid #fff;
        border-bottom: 1px solid #fff;
        margin-bottom: 10px;
        border-radius: 0 0 8px 8px;
        position: relative;

        .ch_bottom::-webkit-scrollbar {
            display: none;
        }

        .ch_bottom {
            width: 100%;
            height: 0;
            flex: 1;
            overflow-y: scroll;
            margin-bottom: 15px;
            box-sizing: border-box;
            padding-bottom: 65px;

            .chb_item {
                width: 100%;
                margin-top: 20px;

                .chb_left {
                    width: 100%;
                    display: flex;
                    align-items: flex-start;

                    .hbl_left {
                        width: 44px;
                        height: 44px;
                        border-radius: 4px;
                    }

                    .hblr_1 {
                        background: transparent !important;
                        padding: 0 !important;
                    }

                    .hbl_right {
                        // flex: 1;
                        margin-left: 20px;
                        width: fit-content;
                        // max-width: 500px;
                        background: #FAFAFA;
                        border-radius: 10px 10px 10px 10px;
                        box-sizing: border-box;
                        padding: 10px;
                        position: relative;

                        .blr_top {
                            font-weight: 500;
                            font-size: 16px;
                            color: #333333;
                            line-height: 32px;

                            .loading-container {
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                height: 100%;
                                // margin-top: 30rpx;
                                box-sizing: border-box;
                                padding: 10px;
                                border-radius: 20px;
                                margin-left: 16px;
                                user-select: auto;
                            }

                            .dot {
                                width: 10px;
                                height: 10px;
                                background-color: #333;
                                border-radius: 50%;
                                margin: 0 5px;
                                animation: blink 1.4s infinite both;
                                opacity: 0;
                            }

                            .dot:nth-child(1) {
                                animation-delay: 0.2s;
                            }

                            .dot:nth-child(2) {
                                animation-delay: 0.4s;
                            }

                            .dot:nth-child(3) {
                                animation-delay: 0.6s;
                            }

                            @keyframes blink {
                                0% {
                                    opacity: 0;
                                }

                                50% {
                                    opacity: 1;
                                }

                                100% {
                                    opacity: 0;
                                }
                            }
                        }

                        .blr_bottom {
                            width: 100%;
                            display: flex;
                            align-items: center;
                            // justify-content: flex-end;
                            border-top: 1px solid#ececec;
                            margin-top: 10px;
                            padding-top: 10px;

                            .lrb_btn {
                                font-weight: 500;
                                font-size: 14px;
                                color: #333333;
                                margin-right: 30px;
                                display: flex;
                                align-items: center;
                                cursor: pointer;

                                img {
                                    width: 14px;
                                    height: 14px;
                                    margin-right: 5px;
                                }
                            }
                        }
                    }
                }

                .chb_right {
                    display: flex;
                    flex-direction: column;
                    // align-items: flex-start;
                    // justify-content: flex-end;


                    .hbr_bottom {
                        display: flex;
                        align-items: center;
                        justify-content: flex-end;

                        .hbr_text {
                            width: fit-content;
                            // max-width: 500px;
                            background: #2992FF;
                            border-radius: 10px 10px 10px 10px;
                            font-weight: 500;
                            font-size: 16px;
                            color: #FFFFFF;
                            line-height: 32px;
                            box-sizing: border-box;
                            padding: 10px;
                        }

                        .hbr_tx {
                            width: 44px;
                            height: 44px;
                            margin-left: 20px;
                            border-radius: 4px;
                        }
                    }

                }
            }
        }

        .o_bottom1 {
            width: 100%;
            // height: 146px;
            background: #FFFFFF;
            box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.03);
            border-radius: 20px 20px 20px 20px;
            border: 1px solid #E9EBF2;
            box-sizing: border-box;
            padding: 20px;
            margin-bottom: 20px;
            position: relative;

            .ob_down {
                width: 30px;
                height: 30px;
                position: absolute;
                top: -60px;
                left: 50%;
                cursor: pointer;
                user-select: none;
                background-color: #fff;
                border-radius: 50%;
            }

            .ob_btn {
                width: 125px;
                height: 45px;
                background: linear-gradient(180deg, #F4F6F9 0%, #FEFEFE 100%);
                box-shadow: 0px 0px 11px 0px rgba(120, 120, 120, 0.12);
                border-radius: 4px 4px 4px 4px;
                border: 1px solid #E9EBF2;
                font-weight: 500;
                font-size: 16px;
                color: #333333;
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                top: -60px;
                left: 0;
                cursor: pointer;
                user-select: none;

                img {
                    width: 20px;
                    height: 20px;
                    margin-right: 10px;
                    pointer-events: none;
                }
            }

            textarea {
                width: 100%;
                height: 56px;
                padding-bottom: 10px;
                border-bottom: 1px solid rgba(188, 188, 188, 0.2);
                font-size: 16px;
            }

            .ob_bottom1 {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                // justify-content: space-between;
                margin-top: 10px;

                .obb_left {
                    width: 90px;
                    height: 30px;
                    background: #F2F9FF;
                    border-radius: 8px 8px 8px 8px;
                    border: 1px solid #2992FF;
                    font-weight: 500;
                    font-size: 14px;
                    color: #2992FF;
                    text-align: center;
                    line-height: 30px;
                }

                .obb_right {
                    display: flex;
                    align-items: center;

                    .bbr_1 {
                        width: 24px;
                        height: 24px;
                        margin-right: 30px;
                        cursor: pointer;
                    }

                    .bbr_2 {
                        width: 30px;
                        height: 30px;
                        cursor: pointer;

                    }
                }
            }
        }
    }

}
</style>